export default {
  mobile: `(min-width: 481px)`,
  tablet: `(min-width: 769px)`,
  desktop: `(min-width: 1025px)`,
  largeScreen: `(min-width: 1280px)`,
};

export const Device = {
  mobile: "481px",
  tablet: "769px",
  desktop: "1025px",
  max: "1440px",
} as const;
